import { render, staticRenderFns } from "./DashboardLibrarian.vue?vue&type=template&id=1acf0120&scoped=true&"
var script = {}
import style0 from "./DashboardLibrarian.vue?vue&type=style&index=0&id=1acf0120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf0120",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardLibrarian.vue
// module id = 964
// module chunks = 0